<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vi"></a><a id="page_vii"></a><span class="small"><strong>CONTENTS</strong></span></h2>
<p class="tocfront"><a class="nounder" href="#/xhtml/06_preface">Preface</a></p>
<p class="tocfront"><a class="nounder" href="#/xhtml/07_ack">Acknowledgments</a></p>
<p class="tocfront"><a class="nounder" href="#/xhtml/ch01"><strong>1</strong> Undercover Man</a></p>
<p class="tocfront"><a class="nounder" href="#/xhtml/ch02"><strong>2</strong> One Hell of a Good Job</a></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample"><strong>3</strong> Serious Business</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample"><strong>4</strong> Bombing Matters</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample"><strong>5</strong> Cat and Mouse</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample"><strong>6</strong> Season of Suffering</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample"><strong>7</strong> Night Riders</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample"><strong>8</strong> This Horrible Brew</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample"><strong>9</strong> A Slight Case of Murder</span><a id="page_viii"></a></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch10" title="Link target outside of Sample"><strong>10</strong> Parable of the Two Goats</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch11" title="Link target outside of Sample"><strong>11</strong> A Temple of Justice</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch12" title="Link target outside of Sample"><strong>12</strong> Taking the Sun Away</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch13" title="Link target outside of Sample"><strong>13</strong> Digging In</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch14" title="Link target outside of Sample"><strong>14</strong> Pain and Anguish</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/ch15" title="Link target outside of Sample"><strong>15</strong> A Search for the Truth</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/epilo" title="Link target outside of Sample">Epilogue: Dealing with the Devil</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/note" title="Link target outside of Sample">Notes</span></p>
<p class="tocfront"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_toc.vue?2112c760